import { Button, spacing, Text } from "@minuthq/meatball-ui-react"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useTranslate } from "src/domains/i18n/use-translate"
import backdropImage from "src/ui/assets/buildings-orange-brown.jpg"
import { PageLayout } from "src/ui/page-layout/page-layout"

import { LoginForm } from "./-login-form"

export const Route = createFileRoute("/login/")({
  component: Login,
})

function Login() {
  const { t, langKeys } = useTranslate()

  return (
    <PageLayout
      title={t(langKeys.sign_in)}
      footer={<Footer />}
      landscapeImageUrl={backdropImage}
      portraitImageUrl={backdropImage}
    >
      <LoginForm />
    </PageLayout>
  )
}

function Footer() {
  const navigate = useNavigate()
  const { t, langKeys } = useTranslate()

  return (
    <div>
      <Text variant="bodyS" color="secondary" marginBottom={spacing.XS}>
        {t(langKeys.sign_in_no_account)}{" "}
        <Button
          variant="minimal"
          color="neutral"
          size="small"
          onClick={() => {
            void navigate({ to: "/signup" })
          }}
        >
          {t(langKeys.create_an_account)}
        </Button>
      </Text>

      <Text variant="bodyS" color="secondary" marginBottom={spacing.XS}>
        <Button
          variant="minimal"
          color="neutral"
          size="small"
          onClick={() => {
            void navigate({ to: "/password/reset" })
          }}
        >
          {t(langKeys.forgot_password)}
        </Button>
      </Text>
    </div>
  )
}
